import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BeginGetHelpIntroInput, GetHelpIntroDto } from './get-help.models';

interface AbpResult<T> {
    result: T;
}

function unwrap<T>(response: T | AbpResult<T>): T {
    return response && typeof response === 'object' && 'result' in response
        ? (response as AbpResult<T>).result
        : (response as T);
}

/**
 * Thin client for GetHelpAppService (introduction state only). Plain JSON HttpClient calls on purpose:
 * AbpHttpInterceptor only pops its error dialog for Blob error bodies (the NSwag proxies), so a failed best-effort
 * call stays silent.
 */
@Injectable({ providedIn: 'root' })
export class GetHelpApiService {
    private readonly url = AppConsts.remoteServiceBaseUrl + '/api/services/app/GetHelp/';

    constructor(private http: HttpClient) {}

    beginIntro(input: BeginGetHelpIntroInput): Observable<GetHelpIntroDto> {
        return this.http
            .post<AbpResult<GetHelpIntroDto> | GetHelpIntroDto>(this.url + 'BeginIntro', input)
            .pipe(map(unwrap));
    }

    completeIntro(): Observable<void> {
        return this.http.post<void>(this.url + 'CompleteIntro', {});
    }
}
